import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Fire } from "@phosphor-icons/react";

export default function BomDetail() {
  const { id } = useParams();
  const [bom, setBom] = useState(undefined); // undefined = loading, null = not found
  const [mats, setMats] = useState({}); // material_id -> {available, reserved, current_stock, unit}

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    api.get("/boms").then((r) => setBom((r.data || []).find((b) => b.id === id) || null)).catch(() => setBom(null));
    api.get("/materials").then((r) => {
      const map = {};
      (r.data || []).forEach((m) => { map[m.id] = m; });
      setMats(map);
    }).catch(() => {});
  }, [id]);

  return (
    <>
      <PageHeader
        title={bom ? bom.name : "BOM"}
        subtitle={bom ? `${bom.model} Oven · ${bom.lines.length} material${bom.lines.length === 1 ? "" : "s"} per unit` : bom === null ? "Not found" : "Loading…"}
      />
      <div className="p-4 sm:p-8">
        <div className="bg-white border border-zinc-300 overflow-x-auto">
          <div className="flex items-center gap-2 px-6 py-4 border-b border-zinc-300 bg-zinc-50">
            <Fire size={18} weight="fill" className="text-primary" />
            <h3 className="font-heading font-bold uppercase tracking-tight text-sm">Bill of Materials · Live Stock</h3>
          </div>
          {bom === undefined ? (
            <p className="p-6 text-sm text-zinc-400">Loading…</p>
          ) : bom === null ? (
            <p className="p-6 text-sm text-zinc-400" data-testid="bom-not-found">This BOM no longer exists.</p>
          ) : (
            <table className="w-full text-sm min-w-[560px]" data-testid="bom-detail-table">
              <thead>
                <tr className="border-b border-zinc-300 bg-zinc-50 text-left">
                  <th className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-zinc-500">Material</th>
                  <th className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-zinc-500 text-right">Qty / Unit</th>
                  <th className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-zinc-500 text-right">Available</th>
                  <th className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-zinc-500 text-right">Booked</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-200">
                {bom.lines.map((l, i) => {
                  const m = mats[l.material_id];
                  const available = m ? m.available : null;
                  const booked = m ? (m.reserved || 0) : null;
                  return (
                    <tr key={`${l.material_id}-${i}`} data-testid={`bom-detail-row-${i}`} className="hover:bg-zinc-50 transition-colors duration-100">
                      <td className="px-6 py-3 text-zinc-800">{l.material_name}</td>
                      <td className="px-6 py-3 text-right font-mono tabular text-zinc-900">{l.qty_per_unit} <span className="text-zinc-400">{l.unit}</span></td>
                      <td className="px-6 py-3 text-right font-mono tabular font-bold text-zinc-900" data-testid={`bom-avail-${i}`}>
                        {available === null ? <span className="text-[#DC2626] text-xs font-sans">removed</span> : <>{available} <span className="text-zinc-400 font-normal">{l.unit}</span></>}
                      </td>
                      <td className="px-6 py-3 text-right font-mono tabular text-[#EA580C]" data-testid={`bom-booked-${i}`}>
                        {booked === null ? "—" : booked > 0 ? booked : "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
